"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _Context = require("./Context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var BellIcon = function BellIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.65 1.008A.859.859 0 1 1 8.96.709a.859.859 0 0 1 1.69.299zM9.54 2.31c-2.768-.315-4.504 1.046-5.207 4.083C3.631 9.429 2.39 11.142.611 11.53c-.72.466-.804.938-.25 1.417.83.719 3.471 1.852 6.87 2.451l.061.011.01.002c3.4.6 6.269.438 7.295.047.684-.261.767-.733.25-1.418-1.539-.974-2.12-3.008-1.741-6.102.378-3.093-.787-4.966-3.495-5.617l-.072-.012zM4.602 15.678a3.044 3.044 0 0 0-.206.709 2.576 2.576 0 0 0 5.072.894c.043-.242.051-.541.027-.774 0 0-1.18-.078-2.452-.303-1.273-.224-2.441-.526-2.441-.526z",
    fill: "#fff"
  }));
};
BellIcon.defaultProps = {
  viewBox: "0 0 16 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PricewatchSubscribeFormDescription = function PricewatchSubscribeFormDescription() {
  var _useContext = (0, _react.useContext)(_Context.SubscribeContext),
    isMobile = _useContext.isMobile,
    state = _useContext.state,
    STATE = _useContext.STATE,
    isNotConfirmedUser = _useContext.isNotConfirmedUser;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  if (state === STATE.ERROR || isNotConfirmedUser) return null;
  return /*#__PURE__*/_react["default"].createElement(StyledDescription, {
    isMobile: isMobile,
    isEdit: state === STATE.EDIT,
    isDone: state === STATE.DONE
  }, state !== STATE.DONE && /*#__PURE__*/_react["default"].createElement(InlineBellIcon, null), t('subscribe.description'));
};
var InlineBellIcon = (0, _styledComponents["default"])(BellIcon).withConfig({
  displayName: "PricewatchSubscribeFormDescription__InlineBellIcon",
  componentId: "sc-12f3tlt-0"
})(["height:12px;margin-right:6px;stroke:#4d4d4d;min-width:10px;max-width:10px;margin-top:2px;"]);
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "PricewatchSubscribeFormDescription__StyledDescription",
  componentId: "sc-12f3tlt-1"
})(["white-space:break-spaces;display:flex;font-size:12px;color:", ";", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blackLight;
}, function (_ref2) {
  var isEdit = _ref2.isEdit,
    isMobile = _ref2.isMobile;
  return isEdit && (0, _styledComponents.css)(["margin-top:", ";"], isMobile ? 'auto' : '18px');
}, function (_ref3) {
  var isDone = _ref3.isDone;
  return isDone && (0, _styledComponents.css)(["justify-content:center;"]);
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile && (0, _styledComponents.css)(["font-size:16px;margin-bottom:8px;align-items:center;", "{min-width:15px;max-width:15px;height:19px;margin-right:8px;}"], InlineBellIcon);
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(PricewatchSubscribeFormDescription);